import useFormSubmit from './functions/useFormSubmit';
import useInputChanges from './functions/useInputChanges';
import useLoadForm from './functions/useLoadForm';

export default function useWorkplaceForm() {
  const {
    name,
    getErrorMessageByFieldName,
    workplaceCode,
    handleWorkplaceCodeChange,
    handleNameChange,
    hasAffreightment,
    setHasAffreightment,
    operator,
    setOperator,
    usesVtAndAffreightment,
    setUsesVtAndAffreightment,
    cep,
    handleCepChange,
    streetName,
    number,
    handleNumberChange,
    complement,
    district,
    city,
    uf,
    isActive,
    isGettingCepInfo,
    lat,
    handleLatChange,
    lng,
    handleLngChange,
    setName,
    setWorkplaceCode,
    setCep,
    setStreetName,
    setIsActive,
    setNumber,
    setComplement,
    setDistrict,
    setCity,
    setUf,
    setIsGettingCepInfo,
    setLat,
    setLng,
    errors,
    checkIfWorkplaceCodeAlreadyExists,
    handleStreetNameChange,
    handleDistrictChange,
    handleCityChange,
    handleUfChange,
    setError,
    removeError,
    selectedWalkDistance,
    handleWalkDistanceSelection,
    setSelectedWalkDistance,
    compareWithDesiredVtValue,
    handleCompareWithDesiredVtValueChange,
    desiredVtValue,
    handleDesiredVtValueChange,
    walkDistance,
    setWalkDistance,
    setCompareWithDesiredVtValue,
    setDesiredVtValue,
    sameWalkDistanceFromCompany,
    sameDesiredVtValueFromCompany,
    setSameWalkDistanceFromCompany,
    setSameDesiredVtValueFromCompany,
    handleSameWalkDistanceFromCompanyChange,
    handleSameDesiredVtValueFromCompanyChange,
    hasKmLimit,
    setHasKmLimit,
    selectedKmLimit,
    setSelectedKmLimit,
    kmLimit,
    kindOfVtSpTrans,
    setKindOfVtSpTrans,
    integratesWithRiocard,
    setIntegratesWithRiocard,
    handleKmLimitSelection,
    setKmLimit,
    transfersBehavior,
    setTransfersBehavior,
    companyTransfersBehavior,
    setCompanyTransfersBehavior,
    sameTransfersBehaviorFromCompany,
    setSameTransfersBehaviorFromCompany,
    handleSameTransfersBehaviorFromCompanyChange,
  } = useInputChanges();

  const {
    isLoading,
    setIsLoading,
    operatorsOptions,
  } = useLoadForm({
    setName,
    setWorkplaceCode,
    setCep,
    setStreetName,
    setNumber,
    setComplement,
    setDistrict,
    setCity,
    setUf,
    setIsGettingCepInfo,
    setLat,
    setLng,
    setHasAffreightment,
    setOperator,
    setUsesVtAndAffreightment,
    setWalkDistance,
    setSelectedWalkDistance,
    setCompareWithDesiredVtValue,
    setDesiredVtValue,
    setSameWalkDistanceFromCompany,
    setSameDesiredVtValueFromCompany,
    setHasKmLimit,
    setKmLimit,
    setSelectedKmLimit,
    setKindOfVtSpTrans,
    setIntegratesWithRiocard,
    setIsActive,
    setTransfersBehavior,
    setCompanyTransfersBehavior,
    setSameTransfersBehaviorFromCompany,
  });

  const {
    isFormValid,
    isSubmitting,
    updateWorkplace,
    createWorkplace,
  } = useFormSubmit({
    name,
    workplaceCode,
    hasAffreightment,
    operator,
    usesVtAndAffreightment,
    cep,
    streetName,
    number,
    complement,
    district,
    city,
    uf,
    lat,
    lng,
    errors,
    compareWithDesiredVtValue,
    desiredVtValue,
    walkDistance,
    sameWalkDistanceFromCompany,
    sameDesiredVtValueFromCompany,
    integratesWithRiocard,
    kindOfVtSpTrans,
    hasKmLimit,
    kmLimit,
    isActive,
    transfersBehavior,
    companyTransfersBehavior,
    sameTransfersBehaviorFromCompany,
  });

  return {
    isLoading,
    name,
    getErrorMessageByFieldName,
    workplaceCode,
    handleWorkplaceCodeChange,
    handleNameChange,
    hasAffreightment,
    setHasAffreightment,
    operator,
    operatorsOptions,
    setOperator,
    usesVtAndAffreightment,
    setUsesVtAndAffreightment,
    cep,
    handleCepChange,
    streetName,
    number,
    handleNumberChange,
    complement,
    district,
    city,
    uf,
    isGettingCepInfo,
    lat,
    handleLatChange,
    lng,
    handleLngChange,
    isFormValid,
    updateWorkplace,
    createWorkplace,
    isSubmitting,
    checkIfWorkplaceCodeAlreadyExists,
    handleStreetNameChange,
    handleDistrictChange,
    handleCityChange,
    handleUfChange,
    setError,
    setIsLoading,
    removeError,
    selectedWalkDistance,
    handleWalkDistanceSelection,
    setSelectedWalkDistance,
    compareWithDesiredVtValue,
    handleCompareWithDesiredVtValueChange,
    desiredVtValue,
    handleDesiredVtValueChange,
    sameWalkDistanceFromCompany,
    sameDesiredVtValueFromCompany,
    handleSameWalkDistanceFromCompanyChange,
    handleSameDesiredVtValueFromCompanyChange,
    hasKmLimit,
    setHasKmLimit,
    selectedKmLimit,
    setSelectedKmLimit,
    kmLimit,
    kindOfVtSpTrans,
    setKindOfVtSpTrans,
    integratesWithRiocard,
    setIntegratesWithRiocard,
    handleKmLimitSelection,
    setKmLimit,
    transfersBehavior,
    setTransfersBehavior,
    companyTransfersBehavior,
    sameTransfersBehaviorFromCompany,
    handleSameTransfersBehaviorFromCompanyChange,
  };
}
